class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.onOverlayClick.bind(this));
    this.addEventListener('click', this.ignorerAppuiOuverture.bind(this), true);
    this.setHeaderCartIconAccessibility();
  }

  /* TILOA, 18/10/2026 : un appui sur le voile moins de 450 ms après l'ouverture est ignoré. C'est le 2e appui d'un
     double appui sur le bouton d'ajout (bouton duo de la fiche) : pendant le glissement d'ouverture, il tombait sur
     le voile et refermait aussitôt le tiroir. La croix, Échap et un appui volontaire sur le voile ensuite ferment
     toujours le tiroir. */
  onOverlayClick() {
    if (this.ouvertLe && Date.now() - this.ouvertLe < 450) return;
    this.close();
  }

  /* TILOA, 18/10/2026 (b) : même 2e appui, mais DANS le tiroir. Sur téléphone le tiroir prend toute la largeur (plus de
     voile exposé) et ses lignes sont en haut : le 2e appui tombait sur la corbeille ou « − » (portefeuille retiré), sur
     « + » (3e portefeuille) ou sur le lien d'une ligne (fiche quittée), jusqu'à ~560 ms après l'ouverture (banc local,
     double appui de 120 à 700 ms, réseau 0 ou 400 ms). Pendant 700 ms après l'ouverture (même délai que le bouton de
     paiement, assets/tiloa-offre-panier.js), un appui sur une commande ou un lien du tiroir est ignoré. Ne sont pas
     concernés : la croix, le voile (règle ci-dessus), Échap, la zone de paiement (bouton et paiements express, déjà
     gardés ou hors thème) ; ensuite, tout appui passe normalement. */
  ignorerAppuiOuverture(event) {
    if (!this.ouvertLe || Date.now() - this.ouvertLe >= 700) return;
    const commande =
      event.target.closest &&
      event.target.closest('a[href], button, input, select, textarea, label, summary, [role="button"], cart-remove-button');
    if (!commande || !commande.closest('.drawer__inner')) return;
    if (commande.closest('.drawer__close, .cart__ctas, .cart__dynamic-checkout-buttons')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this.ouvertLe = Date.now();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.onOverlayClick.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
